import { Outlet } from 'react-router-dom';
import DashboardHeaderComponent from "./dashboardheader.component";

const Layout = () => {

    return (
        <>
            <DashboardHeaderComponent />
            <Outlet />
        </>
    )
}

export default Layout;